<template>
    <v-combobox :items="items" @input="$emit('input', value)" outlined dense :label="label">
    </v-combobox>
</template>
<script>
export default {
    props:["label","value", "items"]
}
</script>